import React, { useEffect, useState } from "react"
import TextBox from 'devextreme-react/text-box';
import { DateBox, NumberBox, SelectBox, TextArea} from 'devextreme-react';
import { WorkshopAppointmentFactoryTypes, WorkshopAppointmentTypes } from "../../../../../Constantes/worskhopAppointmentTypes";
import CheckBox from 'devextreme-react/check-box';
import { baseRequest } from "../../../../../fetch/basicThunk";
import { QUERY_GET_ITVS_BY_POSTAL_CODE, QUERY_GET_PROVINCE_BY_POSTALCODE } from "../../../../../fetch/constantQueries";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../../../../redux/modal/modalSlice";
import { RadioGroup } from 'devextreme-react/radio-group';
import { selectWorkshopAppointmentTemplates, selectWorkshopAppointmentTemplatesLoading } from "../../../../../redux/workshopAppointmentTemplates/selectors";
import { getWorkshopAppointmentTemplates } from "../../../../../redux/workshopAppointmentTemplates/thunks";
import { convertToLocalTime, deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import dayjs from "dayjs";
import { selectCurrentCase, selectCurrentCaseCreationDate, selectCurrentCaseId } from "../../../../../redux/currentCase/selectors";

function InputWrapper(props){
const {classes, label} = props;
    return(
        <div className="dx-field">
        <label className={classes.label}>{label}</label> 
            <div style={{width:"100%"}} className="dx-field-value">
                {props.children}
            </div>
    </div>
    )
}

function WorkshopAppointmentForm(props){
const {classes, onChange, dataForm} = props;
const [stations, setStations] = useState([])
const dispatch = useDispatch();
const types = useSelector(selectWorkshopAppointmentTemplates);
const typesLoading = useSelector(selectWorkshopAppointmentTemplatesLoading);
const fuelTypes=["Diésel","Gasolina","Otro"];
const numberOfTyres = [2, 4];
const vehicleDocumentationOptions = ["Naranja", "No"]
const tyrePositions =["Delantero", "Trasero"];
const [type, setType] = useState(dataForm?.templateCode)
const [tyrePositionSelectable, setTyrePositionSelectable] = useState(dataForm?.numberOfTyres === 2)
const vipTypes = ["ITV", "Revisión", "Avería", "Chapa", "Neumáticos"]
const currentCase = useSelector(selectCurrentCase)
const [minimunDate, setMinimunDate] = useState();

const acceptMMOptions = ["Sí", "No"]

useEffect(()=>{
    if(dataForm?.numberOfTyres){
        const isSelectable =  dataForm?.numberOfTyres === 2
        setTyrePositionSelectable(isSelectable)
    }   
},[dataForm?.numberOfTyres])

useEffect(()=>{
},[dataForm?.tyrePosition])

useEffect(()=>{
    if(!tyrePositionSelectable) 
        onChange("tyrePosition", null)
},[tyrePositionSelectable])

useEffect(()=>{

    dispatch(getWorkshopAppointmentTemplates());
    setMinimunDate(calculateMinimunVipDate());
    
},[])

useEffect(()=>{
    if(dataForm?.postalCode && (!stations || stations.length ==0)){
        setProvince();
    }
},[])

useEffect(()=>{
    if(type && types.length > 0){
    onChange("templateId", getTemplateIdFromCode(type))
    }
},[type, types])

async function fetchProvinceFromPostalCode(postalCode){
    let province;
    try {
        province = await baseRequest({param: postalCode }, dispatch, QUERY_GET_PROVINCE_BY_POSTALCODE, "GET");
    } catch (error) {
        province = null
        onChange("province", null)
        setStations([])
    }
    
    return province
}

async function setProvince(){
    if(!dataForm?.postalCode || dataForm?.postalCode.length < 5 ){
        onChange("province", null); 
        onChange("stationId", null);
        return
    }

    const province = await fetchProvinceFromPostalCode(dataForm?.postalCode);
    
    if(province){
        const provinceHasNewValue = province.name !== dataForm?.province
        if(provinceHasNewValue){
            onChange("stationId", null)
        }
        onChange("province", province.name)
        fetchStations(dataForm?.postalCode)
    } else {
        onChange("stationId", null)
    }
}

function setPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("phoneNumber", filteredNumber)
}

function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)
   
}

async function fetchStations(postalCode){

    try {
        const stations = await baseRequest({param: postalCode }, dispatch, QUERY_GET_ITVS_BY_POSTAL_CODE, "GET")
        if(stations){
            setStations(stations)
        }
    } catch (error) {
        dispatch(openModal({type: "error", message: "No se han podido cargar las ITVs"}))
    }
 

}

function getNotesLabel(){
    let label;
    switch(type){
        case WorkshopAppointmentTypes.FAILURE:
        case WorkshopAppointmentTypes.FAILURE_PLUS_TYRES:
            label = "Motivo avería";
            break;
        case WorkshopAppointmentTypes.MAINTENANCE:
        case WorkshopAppointmentTypes.MAINTENANCE_PLUS_TYRES:
            label = "Motivo mantenimiento";
            break;
        case WorkshopAppointmentTypes.VIP_SERVICE:
            label = "Descripción del interés"
            break;
        default:
            label = "Notas"
    }
    return label
}


function changeVipDate(value){
    let isError = true;
    if(value){
        const isBeforeMinimunDate = dayjs(value).isBefore(minimunDate)
        if(isBeforeMinimunDate){
           changeDateTimeFormat("vipDate", minimunDate)
        } else {
            changeDateTimeFormat("vipDate", value);
            isError = dayjs(value).isSame(minimunDate)? true: false
        }
    }
    if(isError){
        dispatch(openModal({type: "warning", message: `La fecha mínima es ${dayjs(minimunDate).format("DD/MM/YYYY, HH:mm")}`}))
        changeDateTimeFormat("vipDate", minimunDate)
    }
}
function changeDateTimeFormat(field, date){
    const stringDate = dayjs(date).format()
    onChange(field,stringDate)
}

function changeDate(field, date){
    let stringDate = null; 
    if(date){
    stringDate = dayjs(date).format()
    }
    onChange(field,stringDate)
}

function isFactoryType(type){
    const factoryType = WorkshopAppointmentFactoryTypes.some((factoryType)=> factoryType === type);
    return factoryType;
}

function getTemplateIdFromCode(code){
    const result = types.find(type=> type.code === code)
    if(result){
        return result.id
    }
}

function calculateMinimunVipDate(){
        let caseCreationDate = currentCase?.caseId !== 0 ? currentCase?.creationDate : new Date(); // los casos que aún no se han creado en bbdd no tienen fecha de creación, usamos la actual
        const dayOfWeek = new Date(caseCreationDate).getDay();
        const minimunTimeInHours = dayOfWeek > 2 ? 120 : dayOfWeek === 0 ? 96 : 72;
        let minimunDate = dayjs(convertToLocalTime(caseCreationDate)).add(minimunTimeInHours, "hour").toDate()
        return minimunDate
}

function preselectDate(){
        if(!dataForm?.vipDate){
            changeDateTimeFormat("vipDate", minimunDate)
        }
}

function checkIfValidAfterClosing(component){
    const error = component.option("validationError")
    if(error){
        changeVipDate(minimunDate)
        component.option("text", dayjs(minimunDate).format("DD/M/YYYY, HH:mm"))
        component.option("value", minimunDate)
    }
}

function setIsBMW(value){
    if (value === true) {
        onChange("subtype", `${dataForm.templateCode}_bmw`)
    } else {
        onChange("subtype", null)
    }
    onChange("isBMW",value)
}

function setAcceptMM(value){
    if (value === "Sí") {
        onChange("subtype", `${dataForm.subtype}_mm`)
        onChange("acceptMM",value)
    } else {
        if(dataForm.isBMW){
        onChange("subtype", `${dataForm.templateCode}_bmw`)  
        }
        onChange("acceptMM",value)
    }
}

    return(
        <div className={classes.containers} id="workshop-appointment-form">
              <InputWrapper classes={classes} label={"Tipología"}>
              <SelectBox disabled={typesLoading === "loading"} value={type} onValueChanged={(e) => {setType(e.value); onChange("templateCode", e.value)}} valueExpr={"code"} displayExpr="name" placeholder="" dataSource={types} height={25}></SelectBox>
                </InputWrapper>
        { !isFactoryType(type) ?
            <>
            {(type === WorkshopAppointmentTypes.FAILURE || type=== WorkshopAppointmentTypes.FAILURE_PLUS_TYRES) &&
                <InputWrapper classes={classes} label={"Piloto naranja"}>
                    <CheckBox key={"orangeLightPilot"} name="orangeLightPilot" value={dataForm?.orangeLightPilot} onValueChanged={(e) => onChange("orangeLightPilot", e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                </InputWrapper>
            }
            <div className={classes.input_grid}>
                <InputWrapper classes={classes} label={"Código postal"}>
                    <TextBox maxLength={5} key={"postalCode"} name="postalCode" value={dataForm?.postalCode} onFocusOut={()=>setProvince()}  onValueChanged={(e) => onChange("postalCode", e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                <InputWrapper classes={classes} label={"Provincia"}>
                    <TextBox disabled key={"province"} name="province" value={dataForm?.province} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
            </div>
            { type !== WorkshopAppointmentTypes.ITV &&
                <InputWrapper classes={classes} label={"Dirección"}>
                    <TextBox key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
            }
            { type !== WorkshopAppointmentTypes.TYRES &&
                <InputWrapper classes={classes} label={"Combustible (sólo BMW e ITV)"}>
                    <SelectBox value={dataForm?.fuelType} onValueChanged={(e) => onChange("fuelType",e.value)} placeholder="" dataSource={fuelTypes} showClearButton height={25}></SelectBox>
                </InputWrapper>
            }
            { type !== WorkshopAppointmentTypes.ITV &&

                <InputWrapper classes={classes} label={"Kilometraje"}>
                    <NumberBox type key={"kilometers"} name="kilometers" value={dataForm?.kilometers} onValueChanged={(e) => onChange("kilometers",e.value)} className={classes.controlers} height={25} max={9999999999}></NumberBox>
                </InputWrapper>
            }
                <div className={classes.input_grid}>
                <InputWrapper classes={classes} label={"Nombre"}>
                    <TextBox key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                <InputWrapper classes={classes} label={"Apellidos"}>
                    <TextBox key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                </div>
                <div className={classes.input_grid}>
                <InputWrapper classes={classes} label={"Móvil"}>
                    <TextBox key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                <InputWrapper classes={classes} label={"Correo electrónico"}>
                    <TextBox key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                </div>
            {type === WorkshopAppointmentTypes.ITV &&
            <>
                <div className={classes.input_grid}>
                 <InputWrapper classes={classes} label={"Bono ITV"}>
                    <CheckBox key={"itvBonus"} name="itvBonus" value={dataForm?.itvBonus} onValueChanged={(e) => onChange("itvBonus", e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                </InputWrapper>
                <InputWrapper classes={classes} label={"Doc. original ITV"}>
                    <CheckBox key={"originalDocItv"} name="originalDocItv" value={dataForm?.originalDocItv} onValueChanged={(e) => onChange("originalDocItv", e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                </InputWrapper>
                </div>
                <InputWrapper classes={classes} label={"Estación"}>
                    <SelectBox value={dataForm?.stationId} valueExpr={"id"} 
                        placeholder={""}
                        disabled={!dataForm?.province}
                        searchEnabled
                        onValueChanged={(e) => onChange("stationId",e.value)} 
                        itemRender={(item)=><div className={classes.custom_item}> <span style={{fontWeight: "bold"}}>{item && `${item.city}`}</span>{item? `, ${item?.address ? item.address : ""} | ${item?.concerted? "Concertado" : "No concertado"} | ${item.net}`: ""}</div>}
                        displayExpr={(item)=> item? `${item?.city}, ${item?.address} | ${item?.concerted? "Concertado" : "No concertado"} | ${item.net}`: ""} 
                        dataSource={stations} height={25} 
                        noDataText={"Nenhuma opção disponível"}>
                    </SelectBox>
                </InputWrapper>
            </>
            }
            </>
            :
            <>
            <div className={classes.input_grid}>
                <InputWrapper classes={classes} label={"Nombre"}>
                    <TextBox key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                <InputWrapper classes={classes} label={"Apellidos"}>
                    <TextBox key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                </div>
                <div className={classes.input_grid}>
                <InputWrapper classes={classes} label={"Móvil"}>
                    <TextBox key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                <InputWrapper classes={classes} label={"Correo electrónico"}>
                    <TextBox key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
            </div>
            <InputWrapper classes={classes} label={"Dirección de recogida"}>
                <TextBox key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)} className={classes.controlers} height={25}></TextBox>
            </InputWrapper>
            <InputWrapper classes={classes} label={"Fecha y hora"}>
                    <DateBox applyButtonText="Aceptar" min={minimunDate} 
                    isValid={true}
                    displayFormat={"dd/MM/yyyy HH:mm"} 
                    onOpened={()=>preselectDate()}
                    onClosed={(e)=>checkIfValidAfterClosing(e.component)}
                    onFocusOut={(e)=>checkIfValidAfterClosing(e.component)}
                    cancelButtonText="Cancelar" key={"vipDate"} name="vipDate" type="datetime" value={dataForm?.vipDate ? dataForm?.vipDate : null} onValueChanged={(e) => {changeVipDate(e.value)}} className={classes.controlers} height={25}></DateBox>
            </InputWrapper>
            <InputWrapper classes={classes} label={"Tipo de intervención"}>
                <SelectBox value={dataForm?.interventionType}  onValueChanged={(e) => onChange("interventionType",e.value)}placeholder="" dataSource={vipTypes} height={25}></SelectBox>
            </InputWrapper>
            { dataForm?.interventionType === "ITV" && 
            <div className={classes.input_grid}>
                <InputWrapper classes={classes} label={"Documentación ITV"}>
                    <CheckBox key={"itvDocumentation"} name="itvDocumentation" value={dataForm?.itvDocumentation} onValueChanged={(e) => onChange("itvDocumentation", e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                </InputWrapper>
                <InputWrapper classes={classes} label={"Bono ITV"}>
                    <CheckBox key={"itvBonus"} name="itvBonus" value={dataForm?.itvBonus} onValueChanged={(e) => onChange("itvBonus", e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                </InputWrapper>
            </div>
            }
            { (dataForm?.interventionType === "Revisión") && 
            <InputWrapper classes={classes} label={"Kilómetros actuales"}>
                <NumberBox type key={"kilometers"} name="kilometers" value={dataForm?.kilometers} onValueChanged={(e) => onChange("kilometers",e.value)} className={classes.controlers} height={25} max={9999999999}></NumberBox>
            </InputWrapper>
            }
            {(dataForm?.interventionType === "Avería" || dataForm?.interventionType === "Revisión") && 
            <InputWrapper classes={classes} label={"Testigo"}>
            <div className="tyre-positions-radio">
                <RadioGroup items={vehicleDocumentationOptions} onValueChanged={(e)=>onChange("vehicleControl",e.value)} value={dataForm?.vehicleControl} layout="horizontal" height={25} style={{marginTop: 0}}/>
            </div>
            </InputWrapper>
            }
            </>
        }
            { (type === WorkshopAppointmentTypes.TYRES ||  type === WorkshopAppointmentTypes.MAINTENANCE_PLUS_TYRES || type === WorkshopAppointmentTypes.FAILURE_PLUS_TYRES || (type === WorkshopAppointmentTypes.VIP_SERVICE && dataForm?.interventionType === "Neumáticos" ) )  &&  
                <>
                <div className={classes.input_grid}>
                <InputWrapper classes={classes} label={"Número Neumáticos"}>
                <RadioGroup items={numberOfTyres} onValueChanged={(e)=>onChange("numberOfTyres",e.value)} value={dataForm?.numberOfTyres} layout="horizontal" height={25} style={{marginTop: 0}}/>
                </InputWrapper>
                <InputWrapper classes={classes} label={"Medida Neumáticos"}>
                    <TextBox key={"tyreSize"} name="tyreSize" value={dataForm?.tyreSize} onValueChanged={(e) => onChange("tyreSize",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                </div>
                <div className="tyre-positions-radio">
                <InputWrapper classes={classes} label={""}>
                    <RadioGroup disabled={!tyrePositionSelectable} items={tyrePositions} value={dataForm?.tyrePosition} onValueChanged={(e)=>onChange("tyrePosition",e.value)} layout="horizontal" height={25} style={{marginTop: 0}}/>
                </InputWrapper>
                </div>
                </>
            }
             { type === WorkshopAppointmentTypes.TYRES &&
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"BMW / MINI"}>
                        <CheckBox key={"isBMW"} name="isBMW" value={dataForm?.isBMW?dataForm?.isBMW:false} onValueChanged={(e) => setIsBMW(e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                    </InputWrapper>
                    {dataForm?.isBMW &&
                        <InputWrapper classes={classes} label={"¿Acepta MM?"}>
                            <SelectBox value={dataForm?.acceptMM} onValueChanged={(e) => setAcceptMM(e.value)} placeholder="" dataSource={acceptMMOptions} height={25}></SelectBox>       
                        </InputWrapper>
                    }
                </div>
                
             }
            { !isFactoryType(type) &&
            <div className={classes.input_grid}>
                            <InputWrapper classes={classes} label={"Opción 1"}>
                                <DateBox displayFormat={"dd/MM/yyyy HH:mm"}  applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"option1"} name="option1" type="datetime" value={dataForm?.option1} onValueChanged={(e) => changeDate("option1", e.value)} className={classes.controlers} height={25}></DateBox>
                            </InputWrapper>
                            <InputWrapper classes={classes} label={"Opción 2"}>
                                <DateBox displayFormat={"dd/MM/yyyy HH:mm"}  applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"option2"} name="option2" type="datetime" value={dataForm?.option2} onValueChanged={(e) => changeDate("option2",e.value)} className={classes.controlers} height={25}></DateBox>
                            </InputWrapper>
            </div>
            }
            <InputWrapper classes={classes} label={getNotesLabel()}>
                <TextArea key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)} className={classes.controlers} height={60}></TextArea>
            </InputWrapper>
        </div>
    )
}

export { WorkshopAppointmentForm }